var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rank-custom-wrapper"},[_c('Tabs',{model:{value:(_vm.activeTab),callback:function ($$v) {_vm.activeTab=$$v},expression:"activeTab"}},[_c('Tab',{attrs:{"header":"Coachs prospectés (scrapping)"}},[_c('ProspectedCoach')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }